import * as React from 'react'
import { Tooltip } from '../../Tooltip'
import { HideThisAction, HideThisOutput, safeBool } from '@utils'
import { Tooltip as DVUITooltip } from '@amzn/dvui/dist/Tooltip';
import { FallbackForm } from '../components/FallbackForm'
import { FeedbackEventPublisher } from "../../../../DVWebNodeFeedback/util/FeedbackEventPublisher";
import * as styles from './HideThisIcon.module.scss'

interface HideThisIconProps extends HideThisAction {
    onClick: (out: HideThisOutput) => void
}


interface HideThisIconState {
    error?: string
}

export class HideThisIcon extends React.Component<HideThisIconProps, HideThisIconState> {
    onAjaxCallSuccessAction: (out: HideThisOutput) => void
    constructor(props: HideThisIconProps) {
        super(props)
        this.state = { error: null }
        this.onAjaxCallSuccessAction = this.onAjaxCallSuccess.bind(this)
    }

    onAjaxCallSuccess(out: HideThisOutput) {
        this.props.onClick(out)
        if (!safeBool(out.success)) {
            this.setState({ error: out.message })
        }
        setTimeout(
            () => new FeedbackEventPublisher().publish({ "userClickedHideThis": "true" }),
            5000
        )
    }

    render() {
        return (<>
            {this.state.error &&
                <DVUITooltip use={"error"}
                    content={this.state.error}
                    startOpen={true}
                    dismissable={true}
                    dismissSeconds={5}
                ><div /></DVUITooltip>
            }
            <Tooltip text={this.props.text}>
                <FallbackForm endpointUrl={this.props.endpoint} onSuccess={
                    [this.onAjaxCallSuccessAction]
                }>
                    <div className={styles.iconSvgWrapper}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="20px" width="20px" className={styles.iconSvg}>
                            <defs />
                            <path fill="currentColor" fill-rule="evenodd" d="M12,20 C10.152,20 8.455,19.367 7.1,18.314 L18.314,7.1 C19.367,8.455 20,10.152 20,12 C20,16.418 16.418,20 12,20 M4,12 C4,7.582 7.582,4 12,4 C13.848,4 15.545,4.633 16.9,5.686 L5.686,16.9 C4.633,15.545 4,13.848 4,12 M12,2 C6.477,2 2,6.477 2,12 C2,17.523 6.477,22 12,22 C17.523,22 22,17.523 22,12 C22,6.477 17.523,2 12,2" transform="translate(-2 -2)" />
                        </svg>
                    </div>
                </FallbackForm>
            </Tooltip></>)
    }
}